import { initialize as initializeDateFormatter } from '@thoughtspot/date-format-util';
import * as logger from '@thoughtspot/logger';
import { CLDR_OVERRIDE_MAP, initialize } from '@thoughtspot/number-format-util';
import { updateDateFormats as importedUpdateDateFormats, updateNumberFormats as importedUpdateNumberFormats, updateStrings as importedUpdateStrings, } from '@thoughtspot/translations';
import enCurrencyJson from 'cldr-data/main/en/currencies.json';
import enNumbersJson from 'cldr-data/main/en/numbers.json';
import currencyDataJson from 'cldr-data/supplemental/currencyData.json';
import likelySubtags from 'cldr-data/supplemental/likelySubtags.json';
import numberingSystem from 'cldr-data/supplemental/numberingSystems.json';
import pluralJson from 'cldr-data/supplemental/plurals.json';
import { get } from 'lodash';
import { supportedLocalesMap, localeIdFromResourceName } from './i18n';
import { getDateFormatsTranslationsPath, getNumbersTranslationsPath, getStringsTranslationsPath, resourceLoader, } from './util';
export { dateFormats } from '@thoughtspot/translations';
const currentLocale = 'en-US';
const currentTZ = 'America/Los_Angeles';
const TRANSLATIONS_PATH = 'node_modules/@thoughtspot/translations/resources';
const BASE_PATH = 'node_modules';
export const localeToMomentLangMap = {
    'ja-JP': 'ja',
    'fr-FR': 'fr',
    'de-DE': 'de',
    'ar-EG': 'ar',
    'en-US': 'en',
    'da-DK': 'da',
    'es-ES': 'es',
    'fi-FI': 'fi',
    'sv-SE': 'sv',
    'nb-NO': 'nb',
    'nl-NL': 'nl',
    'pt-PT': 'pt',
    'it-IT': 'it',
    'ru-RU': 'ru',
};
const loggerInstance = logger.create('numberUtil');
export const getNewLocaleId = (locale) => {
    const overrideLocale = CLDR_OVERRIDE_MAP[locale] ?? locale;
    const newLocale = supportedLocalesMap[overrideLocale] || overrideLocale;
    return localeIdFromResourceName[newLocale] ?? currentLocale;
};
async function updateNumberFormats(locale, customNumberFormats = null) {
    const newLocaleId = getNewLocaleId(locale);
    const resourcePath = getNumbersTranslationsPath(newLocaleId);
    let localeData = customNumberFormats;
    if (!localeData) {
        localeData = await resourceLoader(resourcePath);
    }
    importedUpdateNumberFormats(localeData);
}
export async function initializeNumberUtil(locale = currentLocale, { customNumberFormats = null, currencyJson = null, numbersJson = null, currencyFormat = null, } = {}) {
    const newLocaleId = getNewLocaleId(locale);
    await updateNumberFormats(newLocaleId, customNumberFormats);
    try {
        await initialize(newLocaleId, likelySubtags, numberingSystem, currencyDataJson, pluralJson, async (languageId) => {
            if (languageId === 'en') {
                return Promise.resolve(enCurrencyJson);
            }
            if (currencyJson) {
                return Promise.resolve(currencyJson);
            }
            const prefix = get(window, 'blink.depsPath', BASE_PATH);
            const value = await fetch(`${prefix}/cldr-data/main/${languageId}/currencies.json`).then(mod => mod.json());
            return value;
        }, async (languageId) => {
            if (languageId === 'en') {
                return Promise.resolve(enNumbersJson);
            }
            if (numbersJson) {
                return Promise.resolve(numbersJson);
            }
            const prefix = get(window, 'blink.depsPath', BASE_PATH);
            const value1 = await fetch(`${prefix}/cldr-data/main/${languageId}/numbers.json`).then(mod => mod.json());
            return value1;
        }, currencyFormat);
    }
    catch (e) {
        loggerInstance.error(e);
    }
}
export async function initializeStrings(locale = currentLocale, customStrings = null) {
    const newLocaleId = getNewLocaleId(locale);
    const resourcePath = getStringsTranslationsPath(newLocaleId);
    const localeData = await resourceLoader(resourcePath);
    importedUpdateStrings(localeData);
    importedUpdateStrings(customStrings);
}
export async function initializeDateFormats(quarterStartMonth = 1, sessionTimezone = currentTZ, locale = currentLocale, customDateFormats = null) {
    const newLocaleId = getNewLocaleId(locale);
    const resourcePath = getDateFormatsTranslationsPath(newLocaleId);
    let localeData = customDateFormats;
    if (!localeData) {
        localeData = await resourceLoader(resourcePath);
    }
    importedUpdateDateFormats(localeData);
    initializeDateFormatter(quarterStartMonth, sessionTimezone, localeToMomentLangMap[newLocaleId]);
}
//# sourceMappingURL=numbers.js.map